const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://ym6iq51ifc.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://robqu54lde.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.barrick.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.barrick.forwoodsafety.com'
  }
};

export default config;